//设置token请求头和content-type
import axios  from "axios";
import Qs from 'qs'
import Vue from 'vue'
import router from '../../router'
Vue.prototype.$axios = axios   //全局注册，使用方法为:this.$axios
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'    
// axios.defaults.baseURL = "http://129.211.113.90:8080/"   

// axios.defaults.baseURL = 'http://192.168.155.2:8085'  // 后端本地
axios.defaults.baseURL = 'https://jbbcs.hzjbqy.cn'  // 后端本地

//请求拦截
axios.interceptors.request.use(function (config) {
  let token = window.localStorage.getItem('token');
  // post参数值为json要把它序列化
  // if (config.method === 'post') {
    config.data = Qs.stringify(config.data)
  //  }  
  if (token) {
    config.headers.common['token'] = token;
  }
  return config;
}, function (error) {
  console.info("error: ");
  console.info(error);
  return Promise.reject(error);
});
axios.interceptors.response.use(function (response) {
  if (response.data && response.data.code) {
    if (parseInt(response.data.code) == 406) {
        window.localStorage.clear()
        router.replace({path:'/login'})
        return;
    }
  }
  return response;
}, function (error) {
  return Promise.reject(error);
})


// WEBPACK FOOTER //
// ./src/assets/js/index.js